import { TranslatePipe } from '@myre/ui-primitive-core';

import { Component, inject } from '@angular/core';

import {
  type IModalComponent,
  type IModalContext,
} from '../../../modal.interface';
import { ModalService } from '../../../modal.service';

@Component({
  selector: 'myre-modal-header-default',
  templateUrl: './app-modal-header-default.component.html',
  styleUrls: ['./app-modal-header-default.component.scss'],
  imports: [TranslatePipe],
})
export class DefaultHeaderComponent implements IModalComponent {
  private _modalService = inject(ModalService);

  public uid: string;
  public context: IModalContext;
  public data: any;

  public ngOnInit(): void {
    const modalData = this._modalService.getModal(this.uid);

    if (modalData) {
      this.context = modalData.context;
      this.data = modalData.header ? modalData.header.data : {};
    }
  }
}
